var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignpost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.35 1.66666H7.46671C7.13337 1.66666 6.81669 1.78333 6.55835 1.98333L4.73335 3.44166C4.00002 4.02499 4.00002 5.13331 4.73335 5.71664L6.55835 7.17498C6.81669 7.38331 7.14171 7.49165 7.46671 7.49165H14.35C15.1583 7.49165 15.8083 6.84165 15.8083 6.03332V3.11665C15.8083 2.31665 15.1583 1.66666 14.35 1.66666Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66671 10H12.55C12.8834 10 13.2001 10.1167 13.4584 10.3167L15.2834 11.775C16.0167 12.3583 16.0167 13.4667 15.2834 14.05L13.4584 15.5083C13.2001 15.7167 12.875 15.825 12.55 15.825H5.66671C4.85837 15.825 4.20837 15.175 4.20837 14.3667V11.45C4.20837 10.65 4.85837 10 5.66671 10Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10V7.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3333V15.8333",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.3333H12.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignpost);
export default __webpack_public_path__ + "static/media/signpost.b65c23b6c3c4a707423b7a37d43eac49.svg";
export { ForwardRef as ReactComponent };